'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Ripple = require('./Ripple');

var _Ripple2 = _interopRequireDefault(_Ripple);

var _theme = require('./theme.css');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (options) {
  return (0, _Ripple2.default)(_extends({}, options, { theme: _theme2.default }));
};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/ripple/index.js
// module id = 224
// module chunks = 0